import React from 'react';
const Loans = () => <div className="service-page"><h1>Loans</h1><p>Get loans for personal, business, or property needs.</p></div>;
export default Loans;
